import { LOAD_CATALOG_ITEMS_FAIL, LOAD_CATALOG_ITEMS_REQUEST, LOAD_CATALOG_ITEMS_SUCCESS } from './actions';
import api from '@/redux/api/catalog';
import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from 'reselect';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';
import { shouldFetchItemsForCatalog } from './item';

/* reducer */
const DEFAULT_STATE = {
    byId: {},
    // TODO move loaded and loading to here from loaded reducer
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    let existing;

    switch (action.type) {
        case LOAD_CATALOG_ITEMS_SUCCESS:
            existing = cloneDeep(state.byId);

            if (action.payload.catalogItems) {
                action.payload.catalogItems.forEach((item) => {
                    existing[item.catalogId] = { ...item };
                });
            }

            return {
                ...state,
                byId: existing,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.catalogItems;
const idSelector = (state: GlobalState, id) => id;

const byIdSelector = createSelector(stateSelector, (state) => state.byId);

const itemsSelector = createSelector([byIdSelector, idSelector], (byId, id) => byId[id] || {});

export const getTotalItemCount: (state: any, selector: any) => any = createSelector(
    itemsSelector,
    (items) => items.totalCount || 0
);

/* ACTION CREATORS */
const loadCatalogItems = (catalogId, cursor, page, count, itemId) => async (dispatch, getState) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            meta: { actionTime: Date.now() },
            payload: catalogId,
            type: LOAD_CATALOG_ITEMS_REQUEST,
        });
        const response = await api.postCatalogItems({
            authToken,
            catalogId,
            count,
            cursor,
            deployment,
            itemId,
            page,
        });

        return dispatch({
            meta: { actionTime: Date.now(), catalogId },
            payload: response.data,
            type: LOAD_CATALOG_ITEMS_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { catalogId },
            payload: error,
            type: LOAD_CATALOG_ITEMS_FAIL,
        });
    }
};

export const fetchCatalogItemsIfNeeded = (
    catalogId: number,
    cursor?: any,
    page?: number,
    count?: number | string,
    itemId?: number
) => async (dispatch: Function, getState: Function) => {
    const needed = shouldFetchItemsForCatalog(getState(), catalogId);
    if (needed) {
        return dispatch(loadCatalogItems(catalogId, cursor, page, count, itemId));
    }
    return Promise.resolve();
};
